<template lang="html">
  <div>
    <div @click="launchFilePicker">
      <slot name="activator">
        <v-btn color="primary">
          Browse <v-icon>mdi-upload</v-icon>
        </v-btn>
      </slot>
      <input
        ref="file"
        :name="uploadFieldName"
        type="file"
        style="display:none"
        @change="onFileChange($event.target.name, $event.target.files)" >
      <StandardDialog
        :show="errorDialog"
        :width="500"
        color="danger">
        <template v-slot:main>
          <p>{{ errorMsg }}</p>
        </template>
        <template v-slot:actions>
          <v-btn color="secondary">Close</v-btn>
        </template>
      </StandardDialog>
    </div>
  </div>
</template>

<script>
import StandardDialog from './StandardDialog'
import Wait from './Wait'
export default {
  components: {
    StandardDialog
  },
  props: {
    vaule: Object
  },
  data: () => ({
    errorDialog: false,
    errorMsg: '',
    uploadFieldName: 'file',
    maxFileSize: 1024
  }),
  created () {},
  mounted () {},
  methods: {
    launchFilePicker () {
      this.$refs.file.click()
    },
    onFileChange (fieldName, file) {
      const { maxSize } = this.maxFileSize
      let imageFile = file[0]
      if (file.length > 0) {
        let size = imageFile.size / maxSize / maxSize
        if (!imageFile.type.match('image.*')) {
          this.errorDialog = true
          this.errorMsg = 'Please Select an Image File to Upload'
        } else if (size > 1) {
          this.errorDialog = true
          this.errorMsg = 'The selected image is too large. Please select an image smaller than 1MB'
        } else {
          let formData = new FormData()
          let imageUrl = URL.createObjectURL(imageFile)
          formData.append(fieldName, imageFile)
          this.$emit('input', { formData, imageUrl })
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
